import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Blf } from 'src/app/models/centrex/blf';
import { BlfType } from 'src/app/models/centrex/blftype';

@Component({
    selector: 'app-blfs-form',
    imports: [MatSelectModule, MatTableModule, MatInputModule, FormsModule],
    templateUrl: './blfs-form.component.html',
    styleUrl: './blfs-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlfsFormComponent implements OnInit {
    private changeDetectorRef = inject(ChangeDetectorRef);

    // Input de la liste des types de BLFs
    blfsTypes = input.required<BlfType[]>();

    // Input des BLFs du périphériques
    blfs = input.required<Blf[]>();

    // Input pour indiquer si c'est pour des BLFs pour les extenders
    isExtensers = input<boolean>(false);

    @ViewChild(MatTable) blfsTable!: MatTable<Blf[]>;

    datasource: MatTableDataSource<Blf>;

    displayedColumns: string[] = ['lineKey', 'type', 'value', 'label', 'lineEntry', 'extension'];

    ngOnInit(): void {
        this.datasource = new MatTableDataSource<Blf>(this.blfs());
    }

    // onChange($event: any) {
    //     this.blfsTable.renderRows();
    //     console.log('datasource: ', this.datasource.data);
    //     console.log('blfs: ', this.blfs());
    //     this.changeDetectorRef.detectChanges();
    // }
    onTypeChange(element: Blf) {
        if (element.type !== 0 && element.lineEntry === 0) {
            element.lineEntry = 1;
        } else if (element.type === 0) {
            element.lineEntry = 0;
            element.value = '';
            element.label = '';
        }
    }
}
